/**
 * import.meta.env の集約。既定値をここ 1 箇所に置き、アプリ内に
 * `import.meta.env` を散らさない。
 */
export const env = {
  /**
   * API のベースパス。本番は CloudFront が /v1.0/* を ALB へ転送する同一オリジン、
   * dev は vite proxy が同形を再現するため、相対パス固定でよい。
   */
  apiBasePath: import.meta.env.VITE_API_BASE_PATH || "/v1.0",
  /** 既定の authentication_identifier（GET /v1.0/authentication-options の identifier）。 */
  defaultAuthenticationIdentifier:
    import.meta.env.VITE_DEFAULT_AUTHENTICATION_IDENTIFIER || "default",
} as const;
